/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ChallengeCategoryDto } from './challenge-category-dto';

/**
 * 
 * @export
 * @interface GetChallengeResponseDto
 */
export interface GetChallengeResponseDto {
    /**
     * Unique identifier
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'deletedAt': string;
    /**
     * Title of the challenge
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'title': string;
    /**
     * Detailed description of the challenge
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'description': string;
    /**
     * Promotional description of the challenge for marketing purposes
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'promotionalDescription'?: string | null;
    /**
     * ID of the organizer
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'organizerId': string;
    /**
     * Whether the challenge is active
     * @type {boolean}
     * @memberof GetChallengeResponseDto
     */
    'isActive': boolean;
    /**
     * Whether the challenge should be promoted/featured
     * @type {boolean}
     * @memberof GetChallengeResponseDto
     */
    'shouldPromote': boolean;
    /**
     * URL of the cover image
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'coverImageUrl': string;
    /**
     * Array of other image URLs
     * @type {Array<string>}
     * @memberof GetChallengeResponseDto
     */
    'otherImagesUrl': Array<string>;
    /**
     * Challenge start date and time in UTC
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'startsAt': string;
    /**
     * Challenge end date and time in UTC
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'endsAt': string;
    /**
     * Array of challenge category options
     * @type {Array<ChallengeCategoryDto>}
     * @memberof GetChallengeResponseDto
     */
    'challengeCategories': Array<ChallengeCategoryDto>;
    /**
     * Challenge status derived from dates and isActive flag
     * @type {string}
     * @memberof GetChallengeResponseDto
     */
    'challengeStatus': GetChallengeResponseDtoChallengeStatusEnum;
}

export const GetChallengeResponseDtoChallengeStatusEnum = {
    NotStarted: 'not_started',
    Ongoing: 'ongoing',
    Ended: 'ended',
    Cancelled: 'cancelled'
} as const;

export type GetChallengeResponseDtoChallengeStatusEnum = typeof GetChallengeResponseDtoChallengeStatusEnum[keyof typeof GetChallengeResponseDtoChallengeStatusEnum];


